import { render } from "./ProductDetailTwo.vue?vue&type=template&id=464dad7d&scoped=true"
import script from "./ProductDetailTwo.vue?vue&type=script&lang=js"
export * from "./ProductDetailTwo.vue?vue&type=script&lang=js"

import "./ProductDetailTwo.vue?vue&type=style&index=0&id=464dad7d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-464dad7d"]])

export default __exports__